// extracted by mini-css-extract-plugin
module.exports = {"colourPaletteBrandingSystems":"styles-module--colourPaletteBrandingSystems--2Dby0","title":"styles-module--title--TIlx_"};